var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/user-history.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-dcdc9f3a!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/user-history.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/UserHistory.vue
// module id = 752
// module chunks = 1